import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { DashboardRestService } from '../dashboard-rest.service';
import { AuthenticationService } from '../../../libraries/libraries.module';
import { formatRupiah } from 'apps/admin-web/src/app/shared/utils';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-withdraw',
  templateUrl: 'withdraw.component.html',
  styleUrls: ['./withdraw.component.scss']
})
export class WithdrawComponent implements OnInit {
  @Input() balance: number = 0;
  @Output() withdrawSuccess = new EventEmitter<void>();
  formatRupiah = formatRupiah;
  isLoading: boolean = false;
  isDealership: boolean = false;
  isOpen: boolean = false;
  withdrawValue: number = 0;
  loadingProfileDealer: boolean = false;
  profileDealer: {
    cp?: string;
    bankAccount?: string;
    bankName?: string;
  } = {};

  openModal() {
    this.isOpen = true;
    this.onGetDealerByUser();
  }

  closeModal() {
    this.isOpen = false;
  }

  constructor(private _DashboardRest: DashboardRestService, public _authentication: AuthenticationService) {}

  onGetDealerByUser() {
    this.loadingProfileDealer = true;
    const userId: string = this._authentication.user?._id;
    this._DashboardRest.getDealerByUser(userId).subscribe(
      data => {
        this.profileDealer = {
          cp: data.cp,
          bankAccount: data.bankAccount,
          bankName: data.bankName
        };
        this.loadingProfileDealer = false;
      },
      error => {
        this.loadingProfileDealer = false;
      }
    );
  }

  onWithdraw() {
    if (
      this.profileDealer.cp === undefined ||
      this.profileDealer.bankAccount === undefined ||
      this.profileDealer.bankName === undefined
    ) {
      Swal.fire({
        icon: 'warning',
        title: 'Informasi Tidak Lengkap',
        text: 'Pastikan semua informasi rekening telah diisi sebelum melanjutkan penarikan.'
      });
      return;
    }

    this.isLoading = true;

    const payload = {
      total: this.withdrawValue
    };

    this._DashboardRest.requestWithdraw(payload).subscribe({
      next: res => {
        this.isLoading = false;
        this.closeModal();
        Swal.fire({
          icon: 'success',
          title: 'Berhasil',
          text: 'Permintaan withdraw berhasil diajukan.'
        });
        this.withdrawSuccess.emit();
      },
      error: err => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: err?.response?.data?.message || 'Something went wrong!'
        });
        this.isLoading = false;
      }
    });
  }

  ngOnInit(): void {}
}
